import { CSSObject } from '@gsc/types'

export function getAllMediaQueries(...input: CSSObject[]): string[] {
  const queries: string[] = []

  for (const css of input) {
    for (const key in css) {
      const value = css[key]

      if (key.startsWith('@media')) {
        queries.push(key)
      }

      if (typeof value === 'object') {
        queries.push(...getAllMediaQueries(value))
      }
    }
  }

  return [...new Set(queries)]
}

export function applyMatchedMedia(css: CSSObject, matches: Record<string, boolean>): CSSObject {
  const result: CSSObject = {}

  for (const key in css) {
    const value = css[key]

    if (key.startsWith('@media')) {
      if (matches[key] && typeof value === 'object') {
        Object.assign(result, applyMatchedMedia(value, matches))
      }
    } else {
      result[key] = typeof value === 'object' ? applyMatchedMedia(value, matches) : value
    }
  }

  return result
}
